import {isObject} from "spoferan-ui/src/helpers/object_helpers";

export default ({app}, inject) => {
    inject('trans', (key, paramsOrDefault = '', defaultText = '') => {
        defaultText = isObject(paramsOrDefault) ? defaultText : paramsOrDefault;

        if (!app.i18n) {
            return defaultText;
        }

        let params = isObject(paramsOrDefault) ? paramsOrDefault : {};

        let localizedText = app.i18n.t(key, params);

        return localizedText === key ? defaultText : localizedText;
    })

    inject('trans_choice', (key, count, paramsOrDefault = '', defaultText = '') => {
        defaultText = isObject(paramsOrDefault) ? defaultText : paramsOrDefault;

        if (!app.i18n) {
            return defaultText;
        }

        let params = isObject(paramsOrDefault) ? paramsOrDefault : {};

        let localizedText = app.i18n.tc(key, count, params);

        return localizedText === key ? defaultText : localizedText;
    })
}